import { defineComponent as f, useSlots as h, computed as r, openBlock as c, createElementBlock as u, normalizeStyle as d, createElementVNode as g, normalizeClass as v, toDisplayString as S } from "vue";
const y = ["fill", "d"], k = /* @__PURE__ */ f({
  __name: "IstIcon",
  props: {
    color: { default: void 0 },
    size: {},
    name: {},
    path: {}
  },
  setup(p) {
    const t = p, l = h(), n = l.default ? l.default() : null, m = n && typeof n[0].children == "string" ? n[0].children : "", a = r(() => {
      const e = t.name && t.name != "" ? t.name : m;
      let i = "", s = "ist-icon notranslate";
      return e && e.startsWith("mdi") && (s += " mdi " + e), e && e.startsWith("r_") && (s += " material-icons-round", i = e.substring(2)), { classString: s, iconName: i };
    }), o = r(() => t.size ?? "24px");
    return (e, i) => e.path != null && e.path != "" ? (c(), u("svg", {
      key: 0,
      "aria-hidden": "true",
      role: "presentation",
      class: "ist-icon",
      viewBox: "0 0 24 24",
      style: d({ height: o.value, width: o.value })
    }, [
      g("path", {
        fill: e.color,
        d: e.path
      }, null, 8, y)
    ], 4)) : (c(), u("i", {
      key: 1,
      "aria-hidden": "true",
      role: "presentation",
      class: v(a.value.classString),
      style: d({ color: e.color, fontSize: o.value })
    }, S(a.value.iconName), 7));
  }
});
export {
  k as default
};
